import { render } from "./Midia.vue?vue&type=template&id=9a75f8fe"
import script from "./Midia.vue?vue&type=script&lang=js"
export * from "./Midia.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__